document.addEventListener('DOMContentLoaded',()=>{
  const open=document.querySelector('[data-menu-open]'), close=document.querySelector('[data-menu-close]'), menu=document.querySelector('[data-mobile-menu]');
  if(open&&menu){open.addEventListener('click',()=>{menu.hidden=false});}
  if(close&&menu){close.addEventListener('click',()=>{menu.hidden=true});}
  document.querySelectorAll('form[action="/cart/add"]').forEach(form=>{
    form.addEventListener('submit',()=>{
      setTimeout(()=>{
        fetch('/cart.js').then(r=>r.json()).then(cart=>{const c=document.querySelector('.cart-count'); if(c)c.textContent=cart.item_count}).catch(()=>{});
      },250);
    });
  });
});
